<template>
  <div class="page-log-in">
    <div class="columns">
      <div class="column is-12">
        <h1 class="title">Iniciar Sesion</h1>
        <form @submit.prevent="verificData">
          <div class="field has-addons">
            <div class="control has-icons-left">
              <input
                type="text"
                class="input is-focused"
                autofocus
                placeholder="Usuario"
                v-model.trim="username"
              >
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </div>
          </div>
          <div class="field has-addons">
            <div class="control has-icons-left">
              <input
                type="password"
                class="input"
                placeholder="contrasena"
                v-model.trim="password"
              >
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <button class="button btn">Iniciar sesion</button>
            </div>
          </div>
          <hr>
          O
          <router-link to="/sign-up">Click aqui</router-link> si aun no tienes una cuenta!
        </form>        
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { toast } from 'bulma-toast'
export default {
  name: 'LogIn',
  data () {
    return {
      username: '',
      password: '',
      errors: []
    }
  },
  mounted() {
    document.title = 'Iniciar sesion | App'
    this.username = this.$route.query.username
  },
  methods: {
    verificData() {
      if (this.username === ''){
        this.errors.push('Por favor introduzca un nombre de usuario!')
      }
      if (this.password === '') {
        this.errors.push('El campo de contrasena incorrecta...')
      }
      if (!this.errors.length){
        const formData = {
          username: this.username,
          password: this.password
        }
        this.submitFormLogIn(formData)
      } else {
        for (let error of this.errors) {
          this.messageError(`${error}`)
        }
        this.errors = []
      }
    },
    messageError(msg) {
      toast({
        message: msg,
        type: 'is-danger',
        duration: 2000,
        pauseOnHover: true,
        dismissible: true,
        animate: true,
        position: 'bottom-right'
      })
    },
    async submitFormLogIn(data){
      try {
        const res =  await axios.post('/api/v1/token/login/',data)
        const token = res.data.auth_token
        this.$store.commit('setToken',{token:token,username:data.username})
        axios.defaults.headers.common['Authorization'] = 'Token ' + token
        
        localStorage.setItem('username',JSON.stringify(data.username))
        localStorage.setItem('token',JSON.stringify(token))
        const toPath = this.$route.query.to || '/cart'
        this.$router.push(toPath)
      } catch (e) { 
        if (e.response) {
          for (let property in e.response.data) {
            this.messageError(`${e.response.data[property]}`)
          }
        } else if (e.message) {
          this.messageError('Por favor intentelo de nuevo')
        }
        this.username = ''
        this.password = ''
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.page-log-in {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  height: 100vh;
}
.btn {
  color: #745192;
  width: 100%;
  background-color: #e5eff1;
  border: #745192 solid 1px;
  transition: all linear 0.1s;
  &:hover {
    background-color: #745192;
    color: #e5eff1;
  }
}
</style>